const credentials = {
  apiKey: "AIzaSyA5gX7q0spiIKWsI6tafYipT7kOeo_1AkQ",
  authDomain: "mytypequizdev.firebaseapp.com",
  projectId: "mytypequizdev",
  storageBucket: "mytypequizdev.appspot.com",
  messagingSenderId: "408890011752",
  appId: "1:408890011752:web:0e1ed1cf49856caeed0bdd",
  measurementId: "G-YV71KKEEV8"
};

export default credentials; 